import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FindControlIdService {
  // TODO: We can use static method for this class and refactor another FindControlIds to static in the future
  static readonly HL7Partner = 'HL7Partner';
  static readonly JobSchedule = 'JobSchedule';
  static readonly ListAccountType = 'ListAccountType';
  static readonly ListAmendmentSource = 'ListAmendmentSource';
  static readonly ListClaimFormat = 'ListClaimFormat';
  static readonly ListEmploymentStatus = 'ListEmploymentStatus';
  static readonly ListClaimStatusPayer = 'ListClaimStatusPayer';
  static readonly ListDominantHand = 'ListDominantHand';
  static readonly ListEthnicity = 'ListEthnicity';
  static readonly ListFindFacilityPerson = 'ListFindFacilityPerson';
  static readonly ListGender = 'ListGender';
  static readonly ListGenderIdentity = 'ListGenderIdentity';
  static readonly ListHistorian = 'ListHistorian';
  static readonly ListIndustry = 'ListIndustry';
  static readonly ListInsuranceCarrier = 'ListInsuranceCarrier';
  static readonly ListInsurancePayerContact = 'ListInsurancePayerContact';
  static readonly ListJob = 'ListJob';
  static readonly ListJobScheduleTimeBase = 'ListJobScheduleTimeBase';
  static readonly ListLabBillCode = 'ListLabBillCode';
  static readonly ListLanguage = 'ListLanguage';
  static readonly ListMacroGroup = 'ListMacroGroup';
  static readonly ListMaritalStatus = 'ListMaritalStatus';
  static readonly ListMedicalServicesType = 'ListMedicalServicesType';
  static readonly ListOccupation = 'ListOccupation';
  static readonly ListPatientCondition = 'ListPatientCondition';
  static readonly ListPatientProgram = 'ListPatientProgram';
  static readonly ListPersonCorporation = 'ListPersonCorporation';
  static readonly ListPersonWeb = 'ListPersonWeb';
  static readonly ListPharmacyClearinghouse = 'ListPharmacyClearinghouse';
  static readonly ListPhoneType = 'ListPhoneType';
  static readonly ListMessageUrgency = 'ListMessageUrgency';
  static ListMessageSubType = 'ListMessageSubType';
  static readonly ListPronoun = 'ListPronoun';
  static readonly ListProblemStatus = 'ProblemStatus';
  static readonly ListRace = 'ListRace';
  static readonly ListRelationship = 'ListRelationship';
  static readonly ListReport = 'ListReport';
  static readonly ListResponsibleParty = 'ListResponsibleParty';
  static readonly ListScrubProfile = 'ListScrubProfile';
  static readonly ListServiceSite = 'ListServiceSite';
  static readonly ListSexualOrientation = 'ListSexualOrientation';
  static readonly ListZip = 'ListZip';
  static readonly ScheduledReport = 'ScheduledReport';
  static readonly UIFilter = 'ListUIFilter';
  static readonly ViewCorporation = 'ViewCorporation';
  static readonly ViewEmployer = 'ViewEmployer';
  static readonly ViewFindPerson = 'ViewFindPerson';
  static readonly ViewFindFacilityPerson = 'ViewFindFacilityPerson';
  static readonly ViewInternalCorporation = 'ViewInternalCorporation';
  static readonly ViewInsuranceCarrier = 'ViewInsuranceCarrier';
  static readonly ViewInsurancePayerContact = 'ViewInsurancePayerContact';
  static readonly ViewPayerPlan = 'ViewPayerPlan';
  static readonly ViewPersonCorporation = 'ViewPersonCorporation';
  static readonly ViewPersonWeb = 'ViewPersonWeb';
  static readonly ViewPharmacy = 'ViewPharmacy';
  static readonly ViewProvider = 'ViewProvider';
  static readonly ViewResponsibleParty = 'ViewResponsibleParty';
  static readonly ViewMedicalServicesProvider = 'ViewMedicalServicesProvider';
  static readonly VisitCheckList = 'ViewFindVisitChecklist';

  readonly AllergyReaction = 'AllergyReaction';
  readonly AmountAllowSchedule = 'AmountAllowSchedule';
  readonly AppointmentHistoryStatusesToExclude = 'AppointmentHistoryStatusesToExclude';
  readonly ChcListApprovalSetting = 'ChcListApprovalSetting';
  readonly FNDHistoryGroup = 'FNDHistoryGroup';
  readonly FacilityPatientProgram = 'FacilityPatientProgram';
  readonly FacilityPortalMessageRouting = 'FacilityPortalMessageRouting';
  readonly FacilityPortalPatient = 'FacilityPortalPatient';
  readonly FacilityServiceSite = 'FacilityServiceSite';
  readonly FeeSchedule = 'FeeSchedule';
  readonly FindProcedureGroupOnly = 'FindProcedureGroupOnly';
  readonly HealthCareServiceLocation = 'HealthCareServiceLocation';
  readonly InsuranceNetworks = 'InsuranceNetworks';
  readonly InternalProviders = 'InternalProviders';
  readonly ListAddIn = 'ListAddIn';
  readonly ListAppointmentStatus = 'ListAppointmentStatus';
  readonly ListAppointmentType = 'ListAppointmentType';
  readonly ListAttachmentType = 'ListAttachmentType';
  readonly ListCacheMachine = 'ListCacheMachine';
  readonly ListCalendar = 'ListCalendar';
  readonly ListClaimClearingHouse = 'ListClaimClearingHouse';
  readonly ListCreditType = 'ListCreditType';
  readonly ListDisease = 'ListDisease';
  readonly ListDocumentLinkingFolderType = 'DocumentLinkingFolderType';
  readonly ListDxTileConfiguration = 'ListDxTileConfiguration';
  readonly ListEduForm = 'ListEduForm';
  readonly ListFilter = 'ListFilterV2';
  readonly ListFindControlBehavior = 'ListFindControlBehavior';
  readonly ListFormattingTemplate = 'ListFormattingTemplate';
  readonly ViewAllFindControl = 'ViewAllFindControl';
  readonly ListHistoryGroup = 'ListHistoryGroup';
  readonly ListHxRelationship = 'ListHxRelationship';
  readonly ListImmzCompletion = 'ListImmzCompletion';
  readonly ListImmzContraindication = 'ListImmzContraindication';
  readonly ListImmzEvidenceOfImmunity = 'ListImmzEvidenceOfImmunity';
  readonly ListImmzHistorySource = 'ListImmzHistorySource';
  readonly ListImmzReaction = 'ListImmzReaction';
  readonly ListImmzRefusal = 'ListImmzRefusal';
  readonly ListImmzSpecialIndications = 'ListImmzSpecialIndications';
  readonly ListLaboratory = 'ListLaboratory';
  readonly ListMacroGroup = 'ViewMacroGroupUser_SelectableV2';
  readonly ListMacroGroupByUser = 'ViewMacroGroupUserV2';
  readonly ListMessageSubType = 'ListMessageSubType';
  readonly ListMessageType = 'ListMessageType';
  readonly ListMessageUrgency = 'ListMessageUrgency';
  readonly ListMisc = 'ListMisc';
  readonly ListObservationItem = 'ListObservationItem';
  readonly ListPrintSet = 'ListPrintSet';
  readonly ListPrmRuleGroup = 'ListPrmRuleGroup';
  readonly ListProcedureModifier = 'ListProcedureModifier';
  readonly ListProcedure = 'ListProcedure';
  readonly ListReimbursementRule = 'ListReimbursementRule';
  readonly ListRoom = 'ListRoom';
  readonly ListSecurityGroup = 'ListSecurityGroup';
  readonly ListTimeFrame = 'ListTimeFrame';
  readonly ListTimespan = 'ListTimespan';
  readonly ListTypeofVaccine = 'ListTypeofVaccine';
  readonly ListVFCEligibility = 'ListVFCEligibility';
  readonly ListVaccineAdmin = 'ListVaccineAdmin';
  readonly ListVaccineFundingSource = 'ListVaccineFundingSource';
  readonly ListVaccineMfr = 'ListVaccineMfr';
  readonly ListVaccineRoute = 'ListVaccineRoute';
  readonly ListVaccineSite = 'ListVaccineSite';
  readonly ListWeightConditions = 'ListWeightConditions';
  readonly NegationReason = 'NegationReason';
  readonly ObservationDefaultSettings = 'ObservationDefaultSettings';
  readonly PatientProblemDiagnosisHistory = 'PatientProblemDiagnosisHistory';
  readonly ProcedureHistoryStatus = 'ProcedureHistoryStatus';
  readonly ProcedureHistoryTerm = 'ProcedureHistoryTerm';
  readonly ProceduresFiltered = 'ProceduresFiltered';
  readonly ProviderWorklist = 'ProviderWorklist';
  readonly RxProviders = 'RxProviders';
  readonly SO = 'SO';
  readonly SO_DST = 'SO_DST';
  readonly SP = 'SP';
  readonly SP_DST = 'SP_DST';
  readonly TypeOfVaccineFiltered = 'TypeOfVaccineFiltered';
  readonly ViewClearinghouseInactive = 'ViewClearinghouseInactive';
  readonly ViewFNDConfiguration = 'ViewFNDConfigurationV2';
  readonly ViewFindPatient = 'ViewFindPatient';
  readonly ViewFindVaccine = 'ViewFindVaccine';
  readonly ViewFindVaccineFiltered = 'ViewFindVaccineFiltered';
  readonly ViewFindVideoAllowedPersonContact = 'ViewFindVideoAllowedPersonContact';
  readonly ViewFindVideoPatientProvider = 'ViewFindVideoPatientProvider';
  readonly ViewHomepageConfiguration = 'ViewHomepageConfiguration';
  readonly ViewMasterPharmacy = 'ViewMasterPharmacy';
  readonly ViewProviderSupervisor = 'ViewProviderSupervisor';
  readonly ViewUserAndUserGroup = 'ViewFindUserAndUserGroup';
  readonly ViewUserAndUserGroupAndFacilityPortalGroup = 'ViewFindUserAndUserGroupAndFacilityPortalGroup';
  readonly ViewUserFilters = 'ViewUserFilters';
  readonly WaitingList = 'WaitingList';
  readonly ListUserSetting = 'ListUserSetting';
  readonly ViewUserDefinedGroupConfiguration = 'ViewUserDefinedGroupConfiguration';
  readonly ListEnrollmentClearingHouse = 'ListEnrollmentClearingHouse';
  readonly ListDemographicsClearingHouse = 'ListDemographicsClearingHouse';
  readonly ListPayerTypologySource = 'ListPayerTypologySource';
  readonly ViewFormBuilder = 'ViewFormBuilder';
  readonly ListUIFilter = 'ListUIFilter';
  readonly ListRPNOptions = 'ListRPNOptions';
  readonly ListRoomFlag = 'ListRoomFlag';

  // Custom Data
  readonly CustomData = 'CustomData';
}
